<template>
    <div>
        <members-listing-filters
            v-if="$vuetify.breakpoint.mdAndUp && !pdf_view"
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
            />
        <v-expansion-panels v-else-if="!pdf_view" flat>
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    <template v-slot:default="{ open }">
                        <v-container class="py-0">
                            <v-row no-gutters>
                                <v-col cols="11" class="tw-text-lg">Filters<span v-show="!!filters_used">: {{ filters_used }}</span></v-col>
                                <v-col cols="1">
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <members-listing-filters
                        v-model="filters"
                        :constants="constants"
                        :valuelists="valuelists"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey">
            <div class="tw-text-xl tw-font-light" v-show="num_members_filtered">{{ num_members_filtered }} Members</div>
            <div v-if="!pdf_view" @click="exportAsPdf()" class="tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Print List</div>
        </div>
        <smart-table
            id="members_list"
            endpoint="memberslisting.list"
            :items="items"
            hide-default-header
            :hide-default-footer="pdf_view"
            :headers="headers"
            :search="filters.search"
            :multi-sort="true"
            :items-per-page="getDefaultItemsPerPage()"
            :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            flat
            ref="members_list"
            @fetch-complete="receivedMembersUpdate"
        >
            <template v-slot:item="{ isMobile, item, header, value, index }">
                <members-listing-item-details
                    v-if="!isMobile"
                    :item="item"
                />
                <v-expansion-panels
                    v-else>
                    <v-expansion-panel>

                        <v-expansion-panel-header hide-actions>
                            <template v-slot:default="{ open }">
                                <v-container class="py-0">
                                    <v-row no-gutters>
                                        <v-col cols="11" class="tw-text-lg tw-text-secondary">{{ getNameForDisplay(item) }}</v-col>
                                        <v-col cols="1">
                                            <v-icon>
                                                <template v-if="open">mdi-minus-circle</template>
                                                <template v-else>mdi-plus-circle</template>
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <members-listing-item-details
                                :item="item"
                                :noname="true"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </template>

        </smart-table>

    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
    import MembersListingItemDetails from "@/Pages/ExternalPages/MembersListingItemDetails.vue";
    import MembersListingFilters from "@/Pages/ExternalPages/MembersListingFilters.vue";

    export default {
        name: "MembersListing",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        components: {
            MembersListingFilters,
            MembersListingItemDetails,
            SmartTable,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    search: null,
                    region: undefined,
                    category: undefined,
                    skill: undefined,
                    province: undefined,
                },
                fetch_data_response: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'last_name',                            text: 'Last Name',                      align: `start`,                 sortable: true,    filterable: true,   },
                    {value: 'functions_active.title_function_id',   text: 'Categories',                     align: `start`,                 sortable: false,   filterable: true,   search: this?.filters?.category },
                    {value: 'region',                               text: 'Region',                         align: ` d-none d-md-block`,    sortable: false,   filterable: true,   search: this?.filters?.region, class: "d-none", cellClass: "d-none" },
                    {value: 'skills.skill_id',                      text: 'Skill',                          align: ` d-none d-md-block`,    sortable: false,   filterable: true,   search: this?.filters?.skill, class: "d-none", cellClass: "d-none" },
                    {value: 'addresses.province_id',                text: 'Province',                       align: ` d-none d-md-block`,    sortable: false,   filterable: true,   search: this?.filters?.province , class: "d-none", cellClass: "d-none" },
                    {value: 'links',                                text: '',                               align: `start`,                 sortable: false,   filterable: true,   },
                ]
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_members_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
            num_members_filtered() {
                return this.fetch_data_response?.data?.recordsFiltered || this.items?.length
            },
            values_regions() {
                if (this?.constants?.MEMBER_REGIONS) {
                    return Object.values(this.constants?.MEMBER_REGIONS)
                }
                return []
            },
            values_categories() {
                if (this?.valuelists?.TITLE_FUNCTIONS_WEBSITE) {
                    return Object.values(this.valuelists?.TITLE_FUNCTIONS_WEBSITE)
                }
                return []
            },
            values_skills() {
                if (this?.valuelists?.SKILLS_GROUPED) {
                    return Object.values(this.valuelists?.SKILLS_GROUPED)
                }
                return []
            },
            values_provinces() {
                if (this?.valuelists?.PROVINCES) {
                    return Object.values(this.valuelists?.PROVINCES)
                }
                return []
            },
        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            receivedMembersUpdate(response) {
                this.fetch_data_response = response
            },
            getNameForDisplay(record) {
                if (!!record?.last_name && !!record?.first_name) {
                    return `${record.last_name}, ${record.first_name}`
                }
                return record?.last_name || record?.first_name
            },
            getFullName(record) {
                if (!!record?.last_name && !!record?.first_name) {
                    return `${record.first_name} ${record.last_name}`
                }
                return record?.last_name || record?.first_name
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 20
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [5, 10, 20, 30]
            },
            async exportAsPdf() {
                let payload = {
                    filter: {
                        'search':                               this.filters.search,
                        'functions_active.title_function_id':   this.filters.category,
                        'region':                               this.filters.region,
                        'skills.skill_id':                      this.filters.skill
                    }
                }

                axios({
                    url: route('memberslisting.export'),
                    method: 'post',
                    data: payload,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the print once it is done.`)
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                    })
            },
        }
    }
</script>

<style>
.row-pointer tbody tr {
    cursor: pointer;
}

td>div:empty {
    display:none !important;
    visibility: hidden !important;
    min-height: unset !important;
}


</style>
